// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"5e039dae","455":"44e0cd9f","977":"cb91e72f"}[chunkId] + ".chunk.js";
};